import { render, staticRenderFns } from "./ClientSignEventHolder.vue?vue&type=template&id=fd49b222&scoped=true&"
import script from "./ClientSignEventHolder.vue?vue&type=script&lang=js&"
export * from "./ClientSignEventHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd49b222",
  null
  
)

export default component.exports